module.exports = __webpack_public_path__ + "static/media/Praxis.e751c484.svg";